module.exports = __webpack_public_path__ + "static/img/frame-login.5d450b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frame-login.png
// module id = N/Br
// module chunks = 201